import React, { useEffect, useMemo, useState } from 'react'

import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useAuthContext } from 'AuthProvider'

import type { Groups } from 'api-client'

interface SelectDateRangeProps {
  value?: string | null
  onChange: (value: string | null) => void
  label?: string
}

const TYPE_GROUP_KEY = 'select_date_range'

function SelectDateRange({
  value,
  onChange,
  label = '期間',
}: SelectDateRangeProps) {
  const { typeCode: typeCodes } = useAuthContext()
  const [groupInfo, setGroupInfo] = useState<Groups | undefined>(undefined)
  const [selectedValue, setSelectedValue] = useState<string>('')

  useEffect(() => {
    if (!typeCodes || typeCodes.length === 0) return
    const group = typeCodes.find((type) => type.typeGroup === TYPE_GROUP_KEY)
    setGroupInfo(group)
  }, [typeCodes])

  const defaultCode = useMemo(() => {
    if (!groupInfo?.codes || groupInfo.codes.length === 0) return undefined
    const defaultItem = groupInfo.codes.find((code) => code.defaultFlg)
    return defaultItem?.typeCode ?? groupInfo.codes[0]?.typeCode
  }, [groupInfo])

  useEffect(() => {
    const nextValue = value ?? defaultCode ?? ''
    setSelectedValue(nextValue ?? '')
    if (!value && defaultCode) {
      onChange(defaultCode)
    }
  }, [value, defaultCode, onChange])

  if (!groupInfo) {
    return (
      <FormControl sx={{ minWidth: 120, mr: 1 }} size="small">
        <CircularProgress color="inherit" size={24} />
      </FormControl>
    )
  }

  return (
    <FormControl sx={{ minWidth: 120, mr: 1 }} size="small">
      <InputLabel id="select-date-range-label">{label}</InputLabel>
      <Select
        labelId="select-date-range-label"
        value={selectedValue}
        label={label}
        onChange={(e) => {
          const next = (e.target.value as string) || ''
          setSelectedValue(next)
          onChange(next || null)
        }}
      >
        {groupInfo.codes.map((code) => (
          <MenuItem key={code.typeCode} value={code.typeCode}>
            {code.typeName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectDateRange

